import { isDefinedArray, isNullOrUndefined, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { observable } from "mobx";

import { apiCallGetMyAuditingMistakes } from "../../../api/auditor-api/api-call-get-my-auditing-mistakes";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { TSupervisedAuditEvent } from "../../../Types";
import getCorePersonalStore from "../../core/core-personal-store";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class MyAuditingMistakesStore {
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  myMistakes = observable.box<TSupervisedAuditEvent[]>([]);

  getMistakes = async () => {
    getCoreUIStore().setIsLoading("AUDITOR_MY_AUDITING_MISTAKES", true);
    const { data, status, code } = await apiCallGetMyAuditingMistakes({
      adminId: reduce(() => getCorePersonalStore().user.get().id, 0),
      dateMin: this.fromDate.get(),
      dateMax: this.toDate.get(),
      limit: 100
    });
    getCoreUIStore().setIsLoading("AUDITOR_MY_AUDITING_MISTAKES", false);
    if (status === "OK") {
      if (!isNullOrUndefined(data) && isDefinedArray(data)) {
        this.myMistakes.set(data);
      } else {
        this.myMistakes.set([]);
        getCorePopUpStore().showAlertMessage("EVENTS_NOT_FOUND");
      }
    } else {
      this.myMistakes.set([]);
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getMyAuditingMistakesStore = memoize(
  () => new MyAuditingMistakesStore(),
  () => 1
);
export default getMyAuditingMistakesStore;
